<template>
  <div v-show="active" class="form-tab-content">
    <slot v-if="hasBeenActive" />
  </div>
</template>

<script>
export default {
  name: 'FormTab',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  inject: ['formTabs'],
  data() {
    return {
      index: -1,
      hasBeenActive: false,
    }
  },
  computed: {
    active() {
      return this.formTabs.activeIndex === this.index
    },
  },
  watch: {
    active(val) {
      if (val) this.hasBeenActive = true
    },
  },
  mounted() {
    this.index = this.formTabs.addTab(this)
    if (this.active) this.hasBeenActive = true
  },
  beforeDestroy() {
    this.formTabs.removeTab(this)
  },
}
</script>
